import { useCallback, useEffect, useState } from "react";
import { fetchBranding } from "../services/branding.service";
import { DEFAULT_BRANDING, type Branding } from "../types";

/**
 * Hook de leitura do branding configurável.
 * Usado em telas pré-login (/auth) e nas configurações do administrador.
 */
export function useBranding() {
  const [branding, setBranding] = useState<Branding>(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchBranding();
      if (data) setBranding(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { branding, loading, refetch };
}
